import React from 'react';
import { DocumentGrid } from './documents/DocumentDisplay';

const AnnualReport = () => {
  return (
    < div >
    <main className="main">
      {/* Page Title */}
      <div className="page-title" data-aos="fade">
        <div className="heading">
          <div className="container">
            <div className="row d-flex justify-content-center text-center">
              <div className="col-lg-8">
                <h2 style={{ fontWeight: "bold" }}>
                  Annual Report
                  <br />
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Page Title */}

      {/* Annual Reports Section */}
      <section id="annual" className="section annual">
        <div className="container">
          <DocumentGrid category="annual_report" />
        </div>
      </section>
      {/* /Annual Reports Section */}
    </main>
    </div >
  )
}

export default AnnualReport;
